import React from 'react';
import { Link } from 'react-router-dom';
import { ROOMS } from '../data/rooms';
import { useSpaces } from '../data/firestore';

// Directory of the room pages (master, west/south/north rooms, entrance
// bathroom). Each card previews its sections' statuses from the live docs.

const STATUS_LABEL = { planning: 'Planning', 'in-progress': 'In progress', done: 'Done' };

export default function RoomsIndex() {
  const { docs: spaces } = useSpaces();
  const byId = new Map((spaces || []).map((s) => [s.id, s]));

  return (
    <div className="cs-page">
      <h1 style={{ marginBottom: 4 }}>Rooms</h1>
      <p className="cs-help" style={{ marginTop: 0 }}>
        Room-by-room build pages — bathroom first, then bedroom, with tabs for
        renders, blueprints, dimensions, studs, electrical and plumbing.
      </p>

      <div className="ah-grid" style={{ marginTop: 18 }}>
        {ROOMS.map((room) => (
          <Link key={room.id} to={`/rooms/${room.id}`} className="cs-card ah-space-card">
            <div style={{ fontSize: 28 }}>{room.icon}</div>
            <strong>{room.name}</strong>
            <p className="cs-help" style={{ margin: '4px 0 8px', fontSize: 13 }}>{room.blurb}</p>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {room.sections.map((s) => {
                const sp = byId.get(s.spaceId);
                return (
                  <span key={s.spaceId} className="ah-status" style={{ fontSize: 11 }}>
                    {s.label}: {STATUS_LABEL[sp?.status] || 'Planning'}
                  </span>
                );
              })}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
